import React from "react";
import Style from "./loyaltyInfoBlock.module.scss";

interface LoyaltyInfoBlockProps {
  number: number;
  title: string;
  children: React.ReactNode;
}

export const LoyaltyInfoBlock = ({
  number,
  title,
  children,
}: LoyaltyInfoBlockProps): JSX.Element => {
  return (
    <div className={Style.info}>
      <div className={Style.info__header}>
        <div className={Style.info__headerNumber}>
          <p>{number}</p>
        </div>
        <p className={Style.info__headerText}>{title}</p>
      </div>
      {children}
    </div>
  );
};
